import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import DataTablePagination from './data-table-pagination';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  loader: {
    display: 'flex',
    paddingTop: theme.spacing(8),
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
  bold: {
    fontWeight: 'bold',
  },
  row: {
    cursor: 'pointer',
  },
}));

type DataTableHeaderType = {
  label: string;
  dataKey?: string;
  renderValue?: (value: any) => any;
  renderColumn?: (row: any) => React.ReactNode;
};

type DataTableProps = {
  columns: DataTableHeaderType[];
  data: object[];
  page?: number;
  maxPages?: number;
  maxResults?: number;
  onPageChange?: (page: number) => void;
  loading?: boolean;
  onSelect?: (row: any) => void;
};

const getRowValue = (column: DataTableHeaderType, row: any) => {
  const value = column?.dataKey?.split('.').reduce((acc, key) => acc && acc[key], row);

  if (column?.renderValue && typeof column.renderValue === 'function') {
    return column?.renderValue(value);
  }

  if (typeof value === 'boolean') {
    return value ? 'OUI' : 'NON';
  }
  return value;
};

const getRow = (column: DataTableHeaderType, row: any) => {
  if (column.renderColumn && typeof column.renderColumn === 'function') {
    return column.renderColumn(row);
  }

  return getRowValue(column, row);
};

export function DataTable({
  columns,
  data,
  page = 0,
  maxPages = 0,
  maxResults = 0,
  onPageChange,
  loading,
  onSelect,
}: DataTableProps) {
  const classes = useStyles();
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} className={classes.root}>
        {loading && (
          <div className={classes.loader}>
            <CircularProgress />
          </div>
        )}
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell key={index} align="left">
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row: any, rowIndex) => (
                <TableRow
                  key={rowIndex}
                  className={classes.row}
                  hover
                  onClick={() => {
                    onSelect?.(row);
                  }}
                >
                  {columns.map((column, index) => (
                    <TableCell
                      component="th"
                      scope="row"
                      key={index}
                      className={row.bold ? classes.bold : ''}
                    >
                      {getRow(column, row)}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination

                  rowsPerPageOptions={[maxResults]}
                  colSpan={columns.length + 1}
                  count={maxResults * maxPages}
                  rowsPerPage={maxResults}
                  page={page - 1}
                  labelRowsPerPage="Nombre de lignes par page"
                  SelectProps={{
                    inputProps: { 'aria-label': 'Nombre de lignes par page' },
                    native: true,
                  }}
                  labelDisplayedRows={({ from, to, count }) => `${from} - ${to}`}
                  onChangePage={(event, page: number) => {
                    if (onPageChange) onPageChange(page);
                  }}
                  onChangeRowsPerPage={() => {}}
                  ActionsComponent={DataTablePagination}
                  onPageChange={() => { }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
}

export default DataTable;
